// extracted by extract-css-chunks-webpack-plugin
module.exports = {"slides_box":"slides_box-1n8bgh9j","tip":"tip-2vCepz5u"};